import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { downloadFile, getFileURL } from '../../helpers';
import AppController from '../../AppController';
import FileShareButton from './MailShareDialog/FileShareButton';
import LocalizedStrings from '../Localization/localization';


class DownloadOrShareFile extends Component {
    handleDownloadFile = async () => {
        if (this.props.fileId !== undefined) {
            if (process.env.REACT_APP_IS_CONTAINER === 'true') {
                await AppController.openFileInContainer(this.props.fileId);
            } else {
                downloadFile(getFileURL(this.props.fileId, this.props.urlModifier));
            }
        }
        this.props.onClose();
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
            >
                <DialogTitle>
                    {LocalizedStrings.downloadOrShareTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {LocalizedStrings.downloadOrShareDescription}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <FileShareButton
                        attachments={this.props.fileId ? [{ identifier: this.props.fileId, resourceSubtype: 'file', urlModifier: this.props.urlModifier }] : []}
                        notify={this.props.notify}
                        buttonComponent={
                            <Button color="primary">
                                {LocalizedStrings.share}
                            </Button>
                        }
                    />
                    <Button onClick={this.handleDownloadFile} color="primary" autoFocus>
                        {LocalizedStrings.viewDownload}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
DownloadOrShareFile.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    notify: PropTypes.func.isRequired,
    fileId: PropTypes.string,
    urlModifier: PropTypes.string,
};

export default DownloadOrShareFile;